import { useCallback, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useBooking } from '../context/BookingContext';
import { clearAllWeatherCaches } from '../components/WeatherWidget';

/**
 * Reloads session + facility data from the server (same effect as logout/login)
 * without ending the session. Use after saving ground location or when widgets
 * look stale on a long-lived app install.
 */
export function useAppRefresh() {
  const { refreshUser } = useAuth();
  const { reloadBookings } = useBooking();
  const [refreshing, setRefreshing] = useState(false);

  const refreshApp = useCallback(async () => {
    setRefreshing(true);
    try {
      clearAllWeatherCaches();
      await refreshUser();
      await reloadBookings();
    } finally {
      setRefreshing(false);
    }
  }, [refreshUser, reloadBookings]);

  return { refreshApp, refreshing };
}
